<template>
  <layout class="iban">
    <h1 slot="title" class="sf-sb">
      {{ $t('iban-page.page-title') }}
    </h1>

    <template slot="nav">
      <nuxt-link v-for="link in links" :key="link" :to="localePath('faq')">
        {{ link }}
      </nuxt-link>
    </template>

    <p>{{ $t('iban-page.description') }}</p>
    <h3 class="sf-sb sf-c-secondary">{{ $t('iban-page.list-title') }}</h3>
    <ol>
      <li v-for="(item, index) in list" :key="`item${index}`">
        {{ item }}
      </li>
    </ol>
  </layout>
</template>

<script>
import Layout from '~/components/layout/sidebar';

export default {
  components: {
    Layout,
  },
  computed: {
    list() {
      return this.$t('iban-page.list');
    },
    links() {
      return this.$t('iban-page.links');
    },
  },
};
</script>
